var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dg-button',{attrs:{"translate":false,"text":_vm.label,"type":"success","icon":"el-icon-download","fieldSize":"mini","click":_vm.downloadWorkingDestinations}})}
var staticRenderFns = []

export { render, staticRenderFns }